import React from "react";

const EmptyScreenLayout = ({ content }) => {
    return (
        <div className="mt-2 text-center p-6">
            {content ? content : "No screens available to display."}
        </div>
    )
}

export default EmptyScreenLayout;